export default {
  pnbon: 0,
  pcpromo: '',
  pcdev: '',
  pmtht: 0,
  pmtttc: 0,
  pmttrsp: 0,

  cart: Array(),
  
  reload_cart: false,

  billing_address: Object(),
  delivery_address: Object(),

  display_billing_address: Object(),
  display_delivery_address: Object(),

  payment_method: '',
  form_cb_ref: Object(),

  last_selected_addr_l: '',
  last_selected_addr_f: '',
  payment_ready: false
};